/* import __COLOCATED_TEMPLATE__ from './priority-changed-by-workflow.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import Component from '@glimmer/component';
import { truncateEventText, isEventTextTruncated } from 'embercom/lib/inbox2/event-text-truncation';
import { priorityLevelName } from 'embercom/lib/inbox/priority-levels';
import type RenderablePart from 'embercom/objects/inbox/renderable-part';
import type PriorityChangedByWorkflow from 'embercom/objects/inbox/renderable/priority-changed-by-workflow';

interface PriorityChangedByWorkflowPart extends RenderablePart {
  renderableData: PriorityChangedByWorkflow;
}

interface Args {
  part: PriorityChangedByWorkflowPart;
}

interface Signature {
  Args: Args;
}

export default class PriorityChangedByWorkflowComponent extends Component<Signature> {
  get newLevel(): string {
    let value = this.args.part.renderableData.priority;
    return value != null ? priorityLevelName(value) : 'urgent';
  }

  get previousLevel(): string {
    let value = this.args.part.renderableData.previousPriority;
    return value != null ? priorityLevelName(value) : 'none';
  }

  truncateTitle(title: string | undefined): string {
    return truncateEventText(title);
  }

  isTitleTruncated(title: string | undefined): boolean {
    return isEventTextTruncated(title);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::EventParts::PriorityChangedByWorkflow': typeof PriorityChangedByWorkflowComponent;
    'inbox2/conversation-stream/event-parts/priority-changed-by-workflow': typeof PriorityChangedByWorkflowComponent;
  }
}
